module.exports = __webpack_public_path__ + "img/ClubManchot_519x428.5e824537.png";